// App.js
import React from 'react';
import './App.css';
import LocationsWidget from './LocationsWidget';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/" element={<LocationsWidget />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
